module.exports = __webpack_public_path__ + "420eea57405f04681bc7389e96b2e6da.png";